const credentials = {
  //prod
  apiUrl: 'https://tourapi.concept3d.com/api/admin',
  tourApiUrl: 'https://tourapi.concept3d.com/api',
  redirectUri: 'http://accounts.concept3d.com/callback',
  accountsAPI: 'https://accountsapi.concept3d.com/api',
  transitAPI: 'https://transitbackend.concept3d.com',
  cmsURL: 'https://cms.concept3d.com', 
};
export default credentials;